/**
 * Códigos de entidad bancaria españoles y su BIC/SWIFT.
 *
 * **Generado**: no se edita a mano. Sale de `data/banks-es.csv` con `node scripts/build-banks-data.mjs`.
 * La fuente es el juego público de códigos de banco de España (código de 4 dígitos → SWIFT de 11, del
 * que se toman los 8 primeros: el banco, sin la oficina).
 *
 * Un BIC equivocado manda el dinero a otro banco, así que esta tabla **no se rellena de memoria**: si un
 * código no está aquí, se deja el campo vacío y lo escribe el usuario.
 */
export const BANCOS_ES: Record<string, { nombre: string; bic: string }> = {
  '0003': { nombre: "Banco de Depositos", bic: 'BDEPESM1' },
  '0011': { nombre: "Allfunds Bank", bic: 'ALLFESMM' },
  '0019': { nombre: "Deutsche Bank", bic: 'DEUTESBBASS' },
  '0021': { nombre: "Banco Condal", bic: 'BCNDESM1' },
  '0030': { nombre: "Banco Español de Credito", bic: 'ESPCESMM' },
  '0031': { nombre: "Banco Etcheverria", bic: 'ETCHES2G' },
  '0036': { nombre: "Santander Investment", bic: 'SABNESMM' },
  '0046': { nombre: "Banco Gallego", bic: 'GALEES2G' },
  '0049': { nombre: "Banco Santander", bic: 'BSCHESMM' },
  '0057': { nombre: "Banco Depositario BBVA", bic: 'BVADESMM' },
  '0058': { nombre: "Bnp Paribas España", bic: 'BNPAESMZ' },
  '0059': { nombre: "Banco de Madrid", bic: 'MADRESMM' },
  '0061': { nombre: "Banca March", bic: 'BMARES2M' },
  '0065': { nombre: "Barclays Bank", bic: 'BARCESMM' },
  '0072': { nombre: "Banco Pastor", bic: 'PSTRESMM' },
  '0073': { nombre: "OPEN Bank", bic: 'OPENESMM' },
  '0075': { nombre: "Banco Popular Español", bic: 'POPUESMM' },
  '0078': { nombre: "Banca Pueyo", bic: 'BAPUES22' },
  '0081': { nombre: "Banco de Sabadell", bic: 'BSABESBB' },
  '0083': { nombre: "Renta 4 Banco", bic: 'RENBESMM' },
  '0086': { nombre: "Banco Banif", bic: 'NORTESMM' },
  '0093': { nombre: "Banco de Valencia", bic: 'VALEESVV' },
  '0094': { nombre: "Rbc Investor Services España", bic: 'BVALESMM' },
  '0099': { nombre: "Bankia Banca Privada", bic: 'AHCRESVV' },
  '0106': { nombre: "Lloyds Tsb Bank PLC, S.E", bic: 'LOYDESMM' },
  '0107': { nombre: "Banca Nazionale del LAVORO, S.P.A., S.E", bic: 'BNLIESM1' },
  '0108': { nombre: "Societe GENERALE, Sucursal en España", bic: 'SOGEESMMAGM' },
  '0113': { nombre: "Banco Industrial de Bilbao", bic: 'INBBESM1' },
  '0121': { nombre: "Banco Occidental", bic: 'OCBAESM1' },
  '0122': { nombre: "Citibank España", bic: 'CITIES2X' },
  '0125': { nombre: "Bancofar", bic: 'BAOFESM1' },
  '0128': { nombre: "Bankinter", bic: 'BKBKESMM' },
  '0129': { nombre: "BBVA Banco de Financiacion", bic: 'INALESM1' },
  '0130': { nombre: "Banco Caixa Geral", bic: 'CGDIESMM' },
  '0131': { nombre: "Banco Espirito SANTO, S.A., Sucursal en España", bic: 'BESMESMM' },
  '0132': { nombre: "Banco de Promocion de NEGOCIOS, S.A. (PROMOBANC)", bic: 'PRNEESM1' },
  '0133': { nombre: "Nuevo Micro Bank", bic: 'MIKBESB1' },
  '0136': { nombre: "Aresbank", bic: 'AREBESMM' },
  '0138': { nombre: "Bankoa", bic: 'BKOAES22' },
  '0144': { nombre: "Bnp Paribas Securities SERVICES, Sucursal en España", bic: 'PARBESMH' },
  '0145': { nombre: "Deutsche Bank A.G., S.E", bic: 'DEUTESM1' },
  '0149': { nombre: "Bnp PARIBAS, Sucursal en España", bic: 'BNPAESMH' },
  '0151': { nombre: "Jpmorgan Chase Bank National ASSOCIATION, S.E", bic: 'CHASESM3' },
  '0152': { nombre: "Barclays Bank PLC, Sucursal en España", bic: 'BPLCESMM' },
  '0154': { nombre: "Credit Agricole Corporate And Investment BANK, SUC. España", bic: 'BSUIESMM' },
  '0155': { nombre: "Banco Do BRASIL, S.A., Sucursal en España", bic: 'BRASESMM' },
  '0156': { nombre: "The Royal Bank Of Scotland PLC, Sucursal en España", bic: 'ABNAESMM' },
  '0159': { nombre: "Commerzbank AKTIENGESELLSCHAFT, Sucursal en España", bic: 'COBAESMXTMA' },
  '0160': { nombre: "The Bank Of TOKYO-MITSUBISHI UFJ, LTD, Sucursal en España", bic: 'BOTKESMX' },
  '0161': { nombre: "Deutsche Bank Trust Company AMERICAS, S.E", bic: 'BKTRESM1' },
  '0162': { nombre: "Hsbc Bank PLC, Sucursal en España", bic: 'MIDLESMX' },
  '0167': { nombre: "Bnp Paribas FORTIS, S.A", bic: 'GEBAESMMBIL' },
  '0168': { nombre: "ING BELGIUM, S.A., Sucursal en España", bic: 'BBRUESMX' },
  '0169': { nombre: "Banco de la Nacion ARGENTINA, Sucursal en España", bic: 'NACNESMM' },
  '0182': { nombre: "Banco Bilbao Vizcaya Argentaria", bic: 'BBVAESMM' },
  '0184': { nombre: "Banco Europeo de Finanzas", bic: 'BEDFESM1' },
  '0186': { nombre: "Banco Mediolanum", bic: 'BFIVESBB' },
  '0188': { nombre: "Banco Alcala", bic: 'ALCLESMM' },
  '0190': { nombre: "Banco BPI, S.A., Sucursal en España", bic: 'BBPIESMM' },
  '0196': { nombre: "Portigon AG, Sucursal en España", bic: 'WELAESMMFUN' },
  '0198': { nombre: "Banco Cooperativo Español", bic: 'BCOEESMM' },
  '0200': { nombre: "Privat Bank Degroof", bic: 'PRVBESB1' },
  '0202': { nombre: "Sociedad Espa Ola de Sistemas de PAGO, S.A. 9", bic: 'IPAYESMM' },
  '0205': { nombre: "Deutsche Bank Credit", bic: 'DECRESM1' },
  '0211': { nombre: "Ebn Banco de Negocios", bic: 'PROAESMM' },
  '0216': { nombre: "Targobank", bic: 'POHIESMM' },
  '0217': { nombre: "Lloyds Bank International", bic: 'HLFXESMM' },
  '0218': { nombre: "Fce Bank Plc S.E", bic: 'FCEFESM1' },
  '0219': { nombre: "Banque Marocaine Commerce Exterieur International", bic: 'BMCEESMM' },
  '0220': { nombre: "Banco Finantia Sofinloc", bic: 'FIOFESM1' },
  '0223': { nombre: "General Electric Capital Bank", bic: 'GEECESB1' },
  '0224': { nombre: "Santander Consumer Finance", bic: 'SCFBESMM' },
  '0225': { nombre: "Banco Cetelem", bic: 'FIEIESM1' },
  '0226': { nombre: "Ubs Bank", bic: 'UBSWESMMNPB' },
  '0227': { nombre: "Unoe Bank", bic: 'UNOEESM1' },
  '0228': { nombre: "Banco Exelbank", bic: 'IXIUESM1' },
  '0229': { nombre: "BANCOPOPULAR-E", bic: 'POPLESMM' },
  '0231': { nombre: "Dexia Sabadell", bic: 'DSBLESMM' },
  '0232': { nombre: "Banco Inversis", bic: 'INVLESMM' },
  '0233': { nombre: "Popular Banca Privada", bic: 'POPIESMM' },
  '0234': { nombre: "Banco Caminos", bic: 'CCOCESMM' },
  '0235': { nombre: "Banco Pichincha España", bic: 'PIESESM1' },
  '0236': { nombre: "Lloyds Bank International", bic: 'LOYIESMM' },
  '0237': { nombre: "Cajasur Banco", bic: 'CSURES2C' },
  '0238': { nombre: "Banco Pastor", bic: 'PSTRESMM' },
  '0239': { nombre: "EVO Banco", bic: 'EVOBESMM' },
  '0240': { nombre: "Banco de Crédito Social Cooperativo", bic: 'BCCAESMM' },
  '0241': { nombre: "AyG Banca Privada", bic: 'PRDVESM1' },
  '0486': { nombre: "Banco Grupo Cajatres", bic: 'TRESES2B' },
  '0487': { nombre: "Banco Mare Nostrum", bic: 'GBMNESMM' },
  '0488': { nombre: "Banco Financiero y de Ahorros", bic: 'BFASESMM' },
  '1000': { nombre: "Instituto de Credito Oficial", bic: 'ICROESMM' },
  '1113': { nombre: "Banque Sudameris", bic: 'BSUDESM1' },
  '1116': { nombre: "Banque Scandinave en Suisse", bic: 'SCSIESM1' },
  '1127': { nombre: "Standard Chartered Bank", bic: 'SCBLESM1' },
  '1156': { nombre: "The Bank Of New York Mellon", bic: 'IRVTESM1' },
  '1164': { nombre: "Espirito Santo Bank Of Florida", bic: 'ESBFESM1' },
  '1168': { nombre: "Banco Nacional de Cuba", bic: 'BNACESM1' },
  '1173': { nombre: "Banque Courtois", bic: 'COURESB1' },
  '1182': { nombre: "Unicredit Bank Ag", bic: 'HYVEESM1' },
  '1191': { nombre: "Svenska Handelsbanken", bic: 'HANDES21' },
  '1193': { nombre: "Pkb Privatbank Ag", bic: 'PKBSES21' },
  '1196': { nombre: "Banco de las Actividades Economicas Exteriores", bic: 'AEEVESM1' },
  '1197': { nombre: "Banque Internationale A Luxembourg", bic: 'BILLESB1' },
  '1199': { nombre: "Banca Carige SPA-CASSA Risparmio Genova E Imperia", bic: 'CRGEESM1' },
  '1209': { nombre: "Allied Banking Corporation", bic: 'ABCMESM1' },
  '1210': { nombre: "Banque Regionale D'ESCOMPTE Et de Depots", bic: 'REDEESM1' },
  '1221': { nombre: "Philippine National Bank", bic: 'PNBMESM1' },
  '1224': { nombre: "Rheinhyp Rheinische Hypothekenbank A.G", bic: 'RHRHESM1' },
  '1227': { nombre: "Banque Scs Alliance", bic: 'BSSAESB1' },
  '1231': { nombre: "Banco Canarias de VENEZUELA, Ca", bic: 'BOCAES21' },
  '1233': { nombre: "Attijariwafa Bank", bic: 'BCMAESM1' },
  '1234': { nombre: "Banco de la Provincia de Buenos Aires", bic: 'PRBAESM1' },
  '1236': { nombre: "Landesbank HESSEN-THUERINGEN Girozentrale", bic: 'HELAESM1' },
  '1238': { nombre: "Banco Internacional", bic: 'BIMEESM1' },
  '1240': { nombre: "London Forfaiting A Paris", bic: 'LOFPESB1' },
  '1241': { nombre: "Banco SBS-AGRO", bic: 'STOLESM1' },
  '1242': { nombre: "Landesbank BADEN-WÃœRTTEMBERG", bic: 'SOLAESB1' },
  '1245': { nombre: "Bes Investimento", bic: 'BEIVESM1' },
  '1248': { nombre: "Wafabank", bic: 'WAFAESM1' },
  '1249': { nombre: "Norwich And Peterborough Building Society", bic: 'NPBSES21' },
  '1251': { nombre: "Privatbank Ihag Zurich", bic: 'IHZUES21' },
  '1255': { nombre: "Aareal Bank Ag", bic: 'AARBESM1' },
  '1451': { nombre: "Caisse Regionale Credit Agricole Mutuel Sud MED,SE", bic: 'CRCGESB1' },
  '1454': { nombre: "Newedge GROUP, S.E", bic: 'NEWGESM1' },
  '1457': { nombre: "De Lage Landen International B.V., S.E", bic: 'LLISESM1' },
  '1459': { nombre: "Cooperatieve Centrale RAIFFEISEN- Boerenleenbank B.A. (RABOB", bic: 'PRABESMM' },
  '1460': { nombre: "Credit Suisse AG, Sucursal en España", bic: 'CRESESMM' },
  '1462': { nombre: "Associates Capital CORPORATION, PLC. S.E", bic: 'ASSCESM1' },
  '1463': { nombre: "Banque Psa FINANCE, S.E", bic: 'PSABESM1' },
  '1464': { nombre: "Newcourt Finance (FRANCE) S.N.C., S.E", bic: 'NFFSESM1' },
  '1465': { nombre: "ING Direct", bic: 'INGDESMM' },
  '1466': { nombre: "FRANFINANCE, S.E", bic: 'FRANESM1' },
  '1467': { nombre: "Hypothekenbank Frankfurt AG. Sucursal en España", bic: 'EHYPESMX' },
  '1469': { nombre: "Banco Sygma HISPANIA, S.E", bic: 'SHSAESM1' },
  '1470': { nombre: "Banco Portugues de INVESTIMENTO, S.A. S.E", bic: 'BPIPESM1' },
  '1472': { nombre: "Credit Agricole Leasing & FACTORING, S.E", bic: 'UCSSESM1' },
  '1473': { nombre: "Banque Privee Edmond de Rothschild EUROPE, S.E", bic: 'PRIBESMX' },
  '1474': { nombre: "Citibank International PLC, Sucursal en España", bic: 'CITIESMXSEC' },
  '1475': { nombre: "Cortal CONSORS, S.E", bic: 'CCSEESM1' },
  '1478': { nombre: "Merrill Lynch International Bank LTD., S.E", bic: 'MLIBESM1' },
  '1479': { nombre: "NATIXIS, S.A., Sucursal en España", bic: 'NATXESMM' },
  '1480': { nombre: "Volkswagen Bank GMBH, S.E", bic: 'VOWAES21' },
  '1485': { nombre: "Bank Of AMERICA, National ASSOCIATION, S.E", bic: 'BOFAES2X' },
  '1488': { nombre: "Pictet & Cie (EUROPE), S.A., S.E", bic: 'PICTESMM' },
  '1490': { nombre: "Self Trade Bank", bic: 'SELFESMM' },
  '1491': { nombre: "Triodos BANK, N.V., S.E", bic: 'TRIOESMM' },
  '1494': { nombre: "Intesa Sanpaolo S.P.A., S.E", bic: 'BCITESMM' },
  '1497': { nombre: "Banco Espirito Santo de INVESTIMENTO, S.A., Sucursal en Espa", bic: 'ESSIESMM' },
  '1501': { nombre: "Deutsche Pfandbriefbank AG, S.E", bic: 'DPBBESM1' },
  '1502': { nombre: "Ikb Deutsche Industriebank AG, S.E", bic: 'IKBDESM1' },
  '1505': { nombre: "Europe Arab Bank PLC, S.E", bic: 'ARABESMM' },
  '1506': { nombre: "Merrill Lynch International Bank LTD., S.E", bic: 'MLCBESM1' },
  '1522': { nombre: "Efg Bank (LUXEMBOURG) S.A., S.E", bic: 'EFGBESMM' },
  '1524': { nombre: "Ubi Banca INTERNATIONAL, S.A., Sucursal en España", bic: 'UBIBESMM' },
  '1525': { nombre: "Banque Chaabi Du MAROC, S.E", bic: 'BCDMESMM' },
  '1534': { nombre: "Kbl European Private BANKERS, S.A. S.E", bic: 'KBLXESMM' },
  '1538': { nombre: "Industrial & Commercial Bank Of CHINA(EUROPE)SA,SE", bic: 'ICBKESMM' },
  '1544': { nombre: "Andbank España", bic: 'BACAESMM' },
  '1545': { nombre: "Credit Agricole LUXEMBOURG, S.E", bic: 'AGRIESMM' },
  '2000': { nombre: "Cecabank", bic: 'CECAESMM' },
  '2010': { nombre: "M.P. y Caja General Ahorros de Badajoz", bic: 'CECAESMM010' },
  '2013': { nombre: "Catalunya Banc", bic: 'CESCESBB' },
  '2017': { nombre: "C.A.M.P. Circulo Catolico de Obreros de Burgos", bic: 'CECAESMM017' },
  '2018': { nombre: "Caja de Ahorros Municipal de Burgos", bic: 'CECAESMM018' },
  '2031': { nombre: "Caja General de Ahorros de Granada", bic: 'CECAESMM031' },
  '2037': { nombre: "Caja de Ahorros de la Rioja", bic: 'CECAESMM037' },
  '2038': { nombre: "Bankia", bic: 'CAHMESMM' },
  '2043': { nombre: "Caja de Ahorros de Murcia", bic: 'CECAESMM043' },
  '2045': { nombre: "Caja de Ahorros y M.P. de Ontinyent", bic: 'CECAESMM045' },
  '2048': { nombre: "Liberbank", bic: 'CECAESMM048' },
  '2051': { nombre: "Caja de Ahorros y M.P. de las Baleares", bic: 'CECAESMM051' },
  '2052': { nombre: "Caja Insular de Ahorros de Canarias", bic: 'CECAESMM052' },
  '2056': { nombre: "Colonya - Caixa D'ESTALVIS de Pollen", bic: 'CECAESMM056' },
  '2065': { nombre: "Caja General de Ahorros de Canarias", bic: 'CECAESMM065' },
  '2066': { nombre: "Caja de Ahorros de Santander y Cantabria", bic: 'CECAESMM066' },
  '2080': { nombre: "Ncg Banco", bic: 'CAGLESMMVIG' },
  '2081': { nombre: "Caixa D'ESTALVIS del Penedes", bic: 'CECAESMM081' },
  '2085': { nombre: "Ibercaja Banco", bic: 'CAZRES2Z' },
  '2086': { nombre: "Banco Grupo Cajatres", bic: 'CECAESMM086' },
  '2095': { nombre: "Kutxabank", bic: 'BASKES2B' },
  '2096': { nombre: "Caja España de INVERSIONES, Caja de Ahorros y M.P", bic: 'CSPAES2L' },
  '2097': { nombre: "Caja de Ahorros de Vitoria y Alava", bic: 'CECAESMM097' },
  '2099': { nombre: "Caja de Ahorros y M.P. de Extremadura", bic: 'CECAESMM099' },
  '2100': { nombre: "Caixabank", bic: 'CAIXESBB' },
  '2101': { nombre: "Caja de Ahorros y M.P. de Gipuzkoa y San Sebastian", bic: 'CGGKES22' },
  '2103': { nombre: "Unicaja Banco", bic: 'UCJAES2M' },
  '2104': { nombre: "Caja de Ahorros de Salamanca y Soria", bic: 'CSSOES2S' },
  '2105': { nombre: "Banco de CASTILLA-LA MANCHA, S.A. /CAJA de Ahorros de CASTILLA-LA Mancha", bic: 'CECAESMM105' },
  '2107': { nombre: "UNNIM Banc", bic: 'BBVAESMM107' },
  '2108': { nombre: "Banco de Caja España de INVERSIONES, Salamanca y Soria", bic: 'CSPAES2L108' },
  '3001': { nombre: "Caja R. de ALMENDRALEJO, S.C.C", bic: 'BCOEESMM001' },
  '3005': { nombre: "Caja R. CENTRAL, S.C.C", bic: 'BCOEESMM005' },
  '3007': { nombre: "Caja R. de GIJON, C.C", bic: 'BCOEESMM007' },
  '3008': { nombre: "Caja R. de NAVARRA, S.C.C", bic: 'BCOEESMM008' },
  '3009': { nombre: "Caja R. de EXTREMADURA, S.C.C", bic: 'BCOEESMM009' },
  '3016': { nombre: "Caja R. de SALAMANCA, S.C.C", bic: 'BCOEESMM016' },
  '3017': { nombre: "Caja R. de SORIA, S.C.C", bic: 'BCOEESMM017' },
  '3018': { nombre: "Caja R.R.S.AGUSTIN de Fuente Alamo M., S.C.C", bic: 'BCOEESMM018' },
  '3020': { nombre: "Caja R. de UTRERA, S.C.A.C", bic: 'BCOEESMM020' },
  '3023': { nombre: "Caja R. de GRANADA, S.C.C", bic: 'BCOEESMM023' },
  '3025': { nombre: "Caixa de Credit Dels Enginyers - Caja Credito Ingenieros", bic: 'CDENESBB' },
  '3029': { nombre: "Caja de Credito de PETREL, Caja RURAL, C.C.V", bic: 'CCRIES2A029' },
  '3035': { nombre: "Caja Laboral POPULAR, C.C", bic: 'CLPEES2M' },
  '3045': { nombre: "Caixa R. ALTEA, C.C.V", bic: 'CCRIES2A045' },
  '3058': { nombre: "Cajas Rurales UNIDAS, S.C.C", bic: 'CCRIES2A' },
  '3059': { nombre: "Caja R. de ASTURIAS, S.C.C", bic: 'BCOEESMM059' },
  '3060': { nombre: "C.R. BURGOS,FUENTEPELAYO,SEGOVIA y CASTELLDANS,SCC", bic: 'BCOEESMM060' },
  '3063': { nombre: "Caja R. de CORDOBA, S.C.C", bic: 'BCOEESMM063' },
  '3067': { nombre: "Caja R. de JAEN, Barcelona y MADRID, S.C.C", bic: 'BCOEESMM067' },
  '3070': { nombre: "Caixa R. GALEGA, S.C.C.L.G", bic: 'BCOEESMM070' },
  '3076': { nombre: "CAJASIETE, Caja RURAL, S.C.C", bic: 'BCOEESMM076' },
  '3080': { nombre: "Caja R. de TERUEL, S.C.C", bic: 'BCOEESMM080' },
  '3081': { nombre: "Caja Rural de CASTILLA-LA MANCHA, S.C.C", bic: 'BCOEESMM081' },
  '3084': { nombre: "Ipar Kutxa RURAL, S.C.C", bic: 'CVRVES2B' },
  '3085': { nombre: "Caja R. de ZAMORA, C.C", bic: 'BCOEESMM085' },
  '3089': { nombre: "Caja R. Baena NTRA. SRA. Guadalupe S.C.C.A", bic: 'BCOEESMM089' },
  '3095': { nombre: "Caja R. S. Roque de Almenara S.C.C.V", bic: 'CCRIES2A095' },
  '3096': { nombre: "Caixa R. de L'ALCUDIA, S.C.V.C", bic: 'BCOEESMM096' },
  '3098': { nombre: "Caja R. NTRA. SRA. del ROSARIO, S.C.A.C", bic: 'BCOEESMM098' },
  '3102': { nombre: "Caixa R. S. Vicent Ferrer de la Vall D'UIXO,C.C.V", bic: 'BCOEESMM102' },
  '3104': { nombre: "Caja R. de Cañete Torres NTRA.SRA.DEL CAMPO,S.C.A", bic: 'BCOEESMM104' },
  '3105': { nombre: "Caixa R. de Callosa D'EN SARRIA, C.C.V", bic: 'CCRIES2A105' },
  '3110': { nombre: "Caja R. Catolico AGRARIA, S.C.C.V", bic: 'BCOEESMM110' },
  '3111': { nombre: "Caixa R. la Vall 'S. ISIDRO', S.C.C.V", bic: 'BCOEESMM111' },
  '3112': { nombre: "Caja R. S. Jose de BURRIANA, S.C.C.V", bic: 'CCRIES2A112' },
  '3113': { nombre: "Caja R. S. Jose de Alcora S.C.C.V", bic: 'BCOEESMM113' },
  '3115': { nombre: "Caja R. 'NUESTRA Madre del SOL', S.C.A.C", bic: 'BCOEESMM115' },
  '3116': { nombre: "Caja R. Comarcal de Mota del CUERVO, S.C.L.C.A", bic: 'BCOEESMM116' },
  '3117': { nombre: "Caixa R. D'ALGEMESI, S.C.V.C", bic: 'BCOEESMM117' },
  '3118': { nombre: "Caixa Rural Torrent C.C.V", bic: 'CCRIES2A118' },
  '3119': { nombre: "Caja R. S. Jaime Alquerias Niño Perdido S.C.C.V", bic: 'CCRIES2A119' },
  '3121': { nombre: "Caja R. de CHESTE, S.C.C", bic: 'CCRIES2A121' },
  '3123': { nombre: "Caixa R. de TURIS, C.C.V", bic: 'CCRIES2A123' },
  '3127': { nombre: "Caja R. de Casas IBAÑEZ, S.C.C.CASTILLA-LA Mancha", bic: 'BCOEESMM127' },
  '3130': { nombre: "Caja R. S. Jose de ALMASSORA, S.C.C.V", bic: 'BCOEESMM130' },
  '3134': { nombre: "Caja R. NTRA. SRA. la Esperanza de ONDA, S.C.C.V", bic: 'BCOEESMM134' },
  '3135': { nombre: "Caja R. S. Jose de Nules S.C.C.V", bic: 'CCRIES2A135' },
  '3137': { nombre: "Caja R. de Casinos S.C.C.V", bic: 'CCRIES2A137' },
  '3138': { nombre: "Caja R. de BETXI, S.C.C.V", bic: 'BCOEESMM138' },
  '3140': { nombre: "Caja R. de GUISSONA, S.C.C", bic: 'BCOEESMM140' },
  '3144': { nombre: "Caja R. de VILLAMALEA, S.C.C.A. CASTILLA-LA Mancha", bic: 'BCOEESMM144' },
  '3146': { nombre: "Caja de Credito COOPERATIVO, S.C.C", bic: 'CCCVESM1' },
  '3150': { nombre: "Caja R. de ALBAL, C.C.V", bic: 'BCOEESMM150' },
  '3152': { nombre: "Caja R. de Villar C.C.V", bic: 'CCRIES2A152' },
  '3157': { nombre: "Caja R. la Junquera de CHILCHES, S.C.C.V", bic: 'CCRIES2A157' },
  '3159': { nombre: "Caixa POPULAR-CAIXA RURAL, S.C.C.V", bic: 'BCOEESMM159' },
  '3160': { nombre: "Caixa R.S.JOSEP de VILAVELLA, S.C.C.V", bic: 'CCRIES2A160' },
  '3162': { nombre: "Caixa R. BENICARLO, S.C.C.V", bic: 'BCOEESMM162' },
  '3165': { nombre: "Caja R. S. Isidro de VILAFAMES, S.C.C.V", bic: 'CCRIES2A165' },
  '3166': { nombre: "Caixa Rural Les Coves de VINROMA, S.C.C.V", bic: 'BCOEESMM166' },
  '3171': { nombre: "Caixa Dels ADVOCATS-CAJA de los ABOGADOS, S.C.C", bic: 'CXAVESB1' },
  '3172': { nombre: "Caja CAMINOS, S.C.C", bic: 'CCOCESMM' },
  '3174': { nombre: "Caixa R. VINAROS, S.C.C.V", bic: 'BCOEESMM174' },
  '3177': { nombre: "Caja R. de CANARIAS, S.C.C", bic: 'BCOEESMM177' },
  '3179': { nombre: "Caja R. de ALGINET, S.C.C.V", bic: 'CCRIES2A179' },
  '3183': { nombre: "Caja de Arquitectos S.C.C", bic: 'CASDESBB' },
  '3186': { nombre: "Caixa R. Albalat Dels SORELLS, C.C.V", bic: 'CCRIES2A186' },
  '3187': { nombre: "Caja R. del SUR, S. COOP. de Credito", bic: 'BCOEESMM187' },
  '3188': { nombre: "Credit VALENCIA, C.R.C.C.V", bic: 'CCRIES2A188' },
  '3190': { nombre: "C.R. de ALBACETE, Ciudad Real y CUENCA, S.C.C", bic: 'BCOEESMM190' },
  '3191': { nombre: "Nueva Caja Rural de Aragon SOC. COOP. de Credito", bic: 'BCOEESMM191' },
  '3501': { nombre: "Renta 4 Sociedad de Valores", bic: 'RENTESMM' },
  '3524': { nombre: "Ahorro Corporacion FINANCIERA, S.A., Sociedad de Valores", bic: 'AHCFESMM' },
  '3563': { nombre: "Mapfre INVERSION, Sociedad de Valores", bic: 'MISVESMM' },
  '3575': { nombre: "INVERSEGUROS, Sociedad de Valores", bic: 'INSGESMM' },
  '3604': { nombre: "Cm Capital Markets BOLSA, Sociedad de Valores", bic: 'CAPIESMM' },
  '3641': { nombre: "Link SECURITIES, Sociedad de Valores", bic: 'LISEESMM' },
  '3656': { nombre: "FINANDUERO, Sociedad de Valores", bic: 'CSSOES2SFIN' },
  '3661': { nombre: "Merrill Lynch Capital Markets ESPAÑA, S.A., Sociedad de Valo", bic: 'MLCEESMM' },
  '3669': { nombre: "Intermoney VALORES, Sociedad de Valores", bic: 'IVALESMM' },
  '3682': { nombre: "Gvc Gaesco VALORES, Sociedad de Valores", bic: 'GVCBESBBETB' },
  '6814': { nombre: "Monty Global Payments", bic: 'MNTYESMM' },
  '6852': { nombre: "Bmce Euroservices", bic: 'BMEUESM1' },
  '8233': { nombre: "Celeris Servicios FINANCIEROS, S.A., E.F.C", bic: 'CSFAESM1' },
  '8512': { nombre: "Union de Creditos INMOBILIARIOS, S.A., E.F.C", bic: 'UCINESMM' },
  '8835': { nombre: "Santander BRASIL, E.F.C", bic: 'SBFCESMM' },
  '9000': { nombre: "Banco de España", bic: 'ESPBESMM' },
  '9091': { nombre: "Sociedad Rectora Bolsa Valores de BARCELONA, S.A., S.R.B.V", bic: 'XBCNESBB' },
  '9092': { nombre: "Sociedad Rectora Bolsa de Valores de BILBAO, S.A., S.R.B.V", bic: 'XRBVES2B' },
  '9093': { nombre: "Sociedad Rectora Bolsa Valores de VALENCIA, S.A., S.R.B.V", bic: 'XRVVESVV' },
  '9094': { nombre: "Meff Sociedad Rectora de Productos Derivados", bic: 'MEFFESBB' },
  '9096': { nombre: "Sociedad de Gestión de los Sistemas de REGISTRO, Compensación y Liquidación de Valores", bic: 'IBRCESMM' },
};
